import { getPublicRuntimeConfig } from '../../libs/init/getPublicRuntimeConfig';
import { ScrollTag, SCROLL_TAG_KEY } from '../useScrollToTag';

/** Path prefix for patient check-in URLs stored as call referrer (e.g. `/v2/check-in/`). */
export const getPatientCheckInPathPrefix = (): string => {
  const { base, checkIn } = getPublicRuntimeConfig().paths;
  return `${base}${checkIn}/`;
};

export const getSlugFromCheckInPathname = (url: string): string | undefined => {
  let pathname: string;
  try {
    // strip any protocol, query, or fragment from the URL we are just interested in pathname
    pathname = new URL(url, globalThis.location?.origin ?? 'https://doxy.me')
      .pathname;
  } catch {
    return;
  }
  const prefix = getPatientCheckInPathPrefix();
  if (!pathname.startsWith(prefix)) {
    return;
  }
  const slug = pathname.slice(prefix.length).replace(/\/+$/u, '');
  return slug === '' ? undefined : slug;
};

export const getCheckInRedirectRoute = (
  roomSlug: string | null | undefined,
): string | undefined => {
  return roomSlug !== undefined && roomSlug !== null && roomSlug !== ''
    ? `${getPatientCheckInPathPrefix()}${roomSlug}`
    : undefined;
};

export const getSettingsPreferencesSelfPreviewVideoRoute = (): string => {
  return `${
    getPublicRuntimeConfig().paths.preferencesSettings
  }?${SCROLL_TAG_KEY}=${ScrollTag.SelfPreviewVideo}`;
};
